export default __webpack_public_path__ + "static/media/zerp-consumption.524752f4.svg";